import "./Statistics.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import {
  FaBasketballBall,
  FaTrophy,
  FaMapMarkerAlt,
  FaSmile,
} from "react-icons/fa";

const Statistics = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    {
      icon: <FaBasketballBall />,
      number: 5500,
      suffix: "+",
      title: "Arenas of Excellence",
      desc: "Seamlessly Engineering world-class surfaces where India's sports legacy takes root.",
    },
    {
      icon: <FaTrophy />,
      number: 15,
      suffix: "+",
      title: "Years of Proven Legacy",
      desc: "Delivering unmatched durability and tournament-grade standards across generations of athletes.",
    },
    {
      icon: <FaMapMarkerAlt />,
      number: 300,
      suffix: "+",
      title: "Cities and Growing",
      desc: "Empowering the next generation of athletes by building world-class facilities in every corner of India.",
    },
    {
      icon: <FaSmile />,
      number: 100,
      suffix: "%",
      title: "Client Trust Retention",
      desc: "Building long-term relationships through flawless execution and dedicated after-sales support.",
    },
  ];

  return (
    <section className="statistics">
      {/* Background Image */}

      <div className="stats-bg"></div>

      {/* Dark Overlay */}

      <div className="stats-overlay"></div>

      <div className="stats-container">
        {/* Heading */}

        <div className="stats-heading">
          <span>OUR IMPACT</span>

          <h2>Building India's Sports Future</h2>

          <p>
            For more than 15 years, Quality Sports Surface has delivered premium
            sports infrastructure that inspires athletes and communities across
            India.
          </p>
        </div>

        {/* Statistics */}

        <div className="stats-grid" ref={ref}>
          {stats.map((item, index) => (
            <div className="stat-item" key={index}>
              <div className="stat-icon">{item.icon}</div>

              <h3>
                {inView ? <CountUp end={item.number} duration={2.5} /> : 0}

                {item.suffix}
              </h3>

              <h4>{item.title}</h4>

              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
